import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css"; // Import CSS styles
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { Link } from 'react-router-dom'
import { ProductContext } from "../context/AppContext";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Footer from './Common_Components/Footer';
const FlashCard = () => {
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    const location = useLocation();
    const navigate = useNavigate();
    const [ttsEnabled, setTtsEnabled] = useState(false);
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);
    // const [showInstruction, setShowInstruction] = useState(true); // Keep for conditional rendering
    // const [isStarted, setIsStarted] = useState(false); // Track whether the user has clicked "Start"
    const [questions, setQuestions] = useState([]);
    const [questionsCondition, setQuestionsCondition] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const FlashData = location.state;
    const categoryId = FlashData?.categoryId;
    const dayId = FlashData?.dayId;
    const unique_day_id = FlashData?.unique_day_id;
    const is_review = FlashData?.is_review;
    const examId = FlashData?.examId;
    const methodType = FlashData?.methodType;
    const examTypes = FlashData?.examTypes;
    const selectedExamId = FlashData?.selectedExamId;
    const LearningId = FlashData?.LearningId;
    const screenTitleId = FlashData?.screenTitleId;
    const resolvedUniqueDayId = unique_day_id || dayId;
    console.log("LearningId Flash", LearningId)
    console.log("Flash Card Data ", categoryId, dayId, is_review, examId, methodType, examTypes)
    const [activePage, setActivePage] = useState("");
    const authToken = localStorage.getItem("AuthToken");
    const { Translate } = useContext(ProductContext);

    const [currentCard, setCurrentCard] = useState(0);
    const [isFlipped, setIsFlipped] = useState(false);
    // const { categoryId, dayId, is_review, examId, methodType } = routes.params;
    // const [isFlipped, setIsFlipped] = useState(false);
    const [isFlipped2, setIsFlipped2] = useState(false);
    const [isFlipAnimating, setIsFlipAnimating] = useState(false);
    const [meaningIndex, setMeaningIndex] = useState(0);

    const [isAiModalOpen, setIsAiModalOpen] = useState(false);
    const [aiLanguage, setAiLanguage] = useState("english"); // 'english' or 'hindi'
    const [aiDisplayedText, setAiDisplayedText] = useState("");

    const postVisit = async () => {
        console.log("postVisit called. Input params:", {
            categoryId,
            LearningId,
            screenTitleId,
            resolvedUniqueDayId,
            examId,
            dayId
        });

        if (!categoryId || !LearningId || !screenTitleId || !resolvedUniqueDayId || !examId) {
            console.warn("postVisit aborted: missing required parameter. Check console log above.");
            return;
        }

        try {
            const token = localStorage.getItem("AuthToken");
            if (!token) {
                console.warn("postVisit aborted: AuthToken not found in localStorage.");
                return;
            }

            console.log("Sending log-visit request to backend...");
            const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
            const response = await fetch(`https://api.japaking.online/api/user-visits/log-visit`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    id: resolvedUniqueDayId,
                    unique_day_id: resolvedUniqueDayId,
                    learning_method_id: LearningId,
                    screen_title_id: screenTitleId,
                    examId,
                }),
            });

            console.log("log-visit response status:", response.status);
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            console.log("log-visit logged successfully!");
        } catch (error) {
            console.log("Error posting flash card visit:", error);
        }
    };

    useEffect(() => {
        postVisit();
    }, [categoryId, LearningId, screenTitleId, dayId, resolvedUniqueDayId, examId]);

    const fetchQuestions = async () => {
        try {
            const url = `https://api.japaking.online/api/vocabulary/dayId/?is_review=${is_review}&dayId=${dayId}&exam_id=${examId}&categoryId=${categoryId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setQuestions(data?.message?.vocabularyData || []);
            setQuestionsCondition(data?.message);
        } catch (error) {
            console.error('Error fetching questions:', error.message);
        }
    };

    useEffect(() => {
        fetchQuestions();
    }, []);

    console.log(questionsCondition?.flipped, "questionsCondition Check Flash Card")

    const [buttonDisabled, setButtonDisabled] = useState(false); // Controls the button's disabled state



    const toggleAudioPlayback = (audioUrl) => {
        if (!audioUrl) {
            console.warn('No audio file URL provided.');
            return;
        }

        try {
            // Stop currently playing audio
            if (global.currentAudio) {
                global.currentAudio.pause();
                global.currentAudio.currentTime = 0;
            }

            // Create a new audio instance
            const audio = new Audio(audioUrl);
            audio.play()
                .then(() => {
                    console.log('Audio is playing...');
                    global.currentAudio = audio;
                })
                .catch((error) => {
                    console.error('Audio playback error:', error);
                });

            // Event when audio ends
            audio.onended = () => {
                console.log('Audio playback finished.');
                global.currentAudio = null;
            };
        } catch (error) {
            console.error('Error playing audio:', error);
        }
    };





    const progressPercentage =
        questions.length > 0 ? (currentCardIndex + 1) / questions.length : 0;

    const handleNextQuestion = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setIsFlipped(false);
            setIsFlipped2(false);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            // Navigate to the results or next page
            console.log('No more questions.');
            navigate('/FlashFinish', {
                state: {
                    categoryId,
                    dayId,
                    is_review,
                    examId,
                    examTypes: examTypes,
                    selectedExamId,
                    LearningId,
                    methodType,
                    screenTitleId,
                    unique_day_id: resolvedUniqueDayId,
                },
            });
        }
    };
    useEffect(() => {
        // Reset meaning index when question changes
        setMeaningIndex(0);
    }, [currentQuestionIndex, questions]);

    const handleBackQuestion = () => {
        if (currentQuestionIndex > 0) {
            setIsFlipped(false);
            setIsFlipped2(false);
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        } else {
            console.log('Already at the first question. Cannot go back further.');
        }
    };
    const [isFront, setIsFront] = useState(true);
    const [isFrontJapanese, setIsFrontJapanese] = useState(true);
    const handleFlipCardJapanese = () => {
        setIsFrontJapanese(!isFrontJapanese);
    };
    const handleFlip = () => {
        setIsFlipAnimating(true);
        setIsFlipped((prev) => !prev); // Toggle the state
        setTimeout(() => {
            setIsFlipAnimating(false);
        }, 600); // match CSS transition duration
        setIsFront(true);

    };

    const handleFlip2 = () => {
        setButtonDisabled(true); // Disable the button while flipping
        setIsFlipped2((prev) => !prev);
    };

    const handleReset = () => {
        setIsFlipped((prev) => !prev);
        setTimeout(() => {
            setIsFlipped(false);
            console.log('Card flipped after reset!');
        }, 2000);
    };



    const handleFlipEndLogic = () => {
        setButtonDisabled(false); // Enable the button when flip animation ends
    };

    console.log('isFlipped Check:', isFlipped);
    console.log(questionsCondition?.flipped, "questionsCondition flipped")



    // const handleFlip = () => {
    //     setIsFlipped(!isFlipped);
    // };

    const progress = ((currentQuestionIndex + 1) / questions.length) * 100;


    const speakJapanese = (text) => {
        if ("speechSynthesis" in window) {
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = "ja-JP"; // Japanese language code
            window.speechSynthesis.speak(utterance);
        } else {
            alert("Speech Synthesis not supported in your browser.");
        }
    };

    const speakText = (text, lang) => {
        if (!text) {
            return;
        }
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = lang;
            window.speechSynthesis.speak(utterance);
        } else {
            alert("Speech Synthesis not supported in your browser.");
        }
    };

    const isJapaneseChar = (char) => {
        const code = char.charCodeAt(0);
        // Hiragana, Katakana, CJK Unified Ideographs (Kanji)
        return (
            (code >= 0x3040 && code <= 0x309F) || // Hiragana
            (code >= 0x30A0 && code <= 0x30FF) || // Katakana
            (code >= 0x4E00 && code <= 0x9FFF)    // Kanji
        );
    };

    const speakHindiExplainWithJapanese = (text) => {
        if (!text) return;
        if (!("speechSynthesis" in window)) {
            alert("Speech Synthesis not supported in your browser.");
            return;
        }

        // Build segments: Japanese parts with ja-JP, others with hi-IN
        const segments = [];
        let current = "";
        let currentLang = null;

        for (let i = 0; i < text.length; i += 1) {
            const ch = text[i];
            const isJa = isJapaneseChar(ch);
            const langForChar = isJa ? "ja-JP" : "hi-IN";

            if (currentLang === null) {
                currentLang = langForChar;
                current = ch;
            } else if (langForChar === currentLang) {
                current += ch;
            } else {
                segments.push({ text: current, lang: currentLang });
                currentLang = langForChar;
                current = ch;
            }
        }

        if (current) {
            segments.push({ text: current, lang: currentLang });
        }

        if (segments.length === 0) {
            return;
        }

        window.speechSynthesis.cancel();
        segments.forEach((segment) => {
            const utterance = new SpeechSynthesisUtterance(segment.text);
            utterance.lang = segment.lang;
            window.speechSynthesis.speak(utterance);
        });
    };

    const renderWithBold = (text) => {
        if (!text) return null;
        const parts = text.split("**");
        return parts.map((part, index) =>
            index % 2 === 1 ? <strong key={index}>{part}</strong> : part
        );
    };

    const openAiModal = () => {
        const current = questions[currentQuestionIndex];
        if (!current) return;
        if (!current.ai_english_explain && !current.ai_hindi_explain) return;
        setAiLanguage(current.ai_english_explain ? "english" : "hindi");
        setIsAiModalOpen(true);
    };

    const closeAiModal = () => {
        setIsAiModalOpen(false);
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
        }
    };

    useEffect(() => {
        if (!isAiModalOpen) {
            setAiDisplayedText("");
            return;
        }

        const current = questions[currentQuestionIndex];
        if (!current) {
            setAiDisplayedText("");
            return;
        }

        const fullText =
            aiLanguage === "english"
                ? current.ai_english_explain
                : current.ai_hindi_explain;

        if (!fullText) {
            setAiDisplayedText("");
            return;
        }

        setAiDisplayedText("");
        let index = 0;
        const intervalId = setInterval(() => {
            index += 1;
            setAiDisplayedText(fullText.slice(0, index));
            if (index >= fullText.length) {
                clearInterval(intervalId);
            }
        }, 0);

        return () => clearInterval(intervalId);
    }, [isAiModalOpen, aiLanguage, currentQuestionIndex, questions]);


    const hasAiExplain =
        questions[currentQuestionIndex]?.ai_english_explain ||
        questions[currentQuestionIndex]?.ai_hindi_explain;
    const showHelpAi = !isFlipped && !isFlipAnimating && hasAiExplain;

    const currentMeanings =
        questions[currentQuestionIndex]?.flash_card_meaning || [];
    const currentMeaningItem =
        currentMeanings.length > 0 ? currentMeanings[meaningIndex] : null;
    const hasMultipleMeanings = currentMeanings.length > 1;

    const handlePrevMeaning = (e) => {
        e.stopPropagation();
        if (currentMeanings.length === 0 || meaningIndex === 0) return;
        setMeaningIndex((prev) => prev - 1);
    };

    const handleNextMeaning = (e) => {
        e.stopPropagation();
        if (currentMeanings.length === 0 || meaningIndex === currentMeanings.length - 1) return;
        setMeaningIndex((prev) => prev + 1);
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                             <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey')} className='icon_1' />
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flashcard-page">
                {/* Rectangle Box */}
                <div className="flashcard-container-box">
                    {/* Content and Button Wrapper */}
                    <div className="flashcard-layout">
                        {/* Left Side - Text, Flashcard, and Progress */}
                        <div className="flashcard-left">
                            {/* Header */}
                            <div className="flashcard-header">
                                <h2>{methodType}</h2>
                            </div>

                            {/* Flashcard */}
                            {questionsCondition?.flipped === true ? (
                                <div className="flashcard-container">
                                    {showHelpAi && (
                                        <button
                                            className="help-ai-button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                openAiModal();
                                            }}
                                        >
                                            Help AI
                                        </button>
                                    )}
                                    {isFlipped && questions[currentQuestionIndex]?.audio_file && (
                                        <button
                                            className="sound-icon"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleAudioPlayback(questions[currentQuestionIndex]?.audio_file);
                                            }}
                                        >
                                            <VolumeUpIcon className="volume-icon" />
                                        </button>
                                    )}
                                    <div
                                        className={`flashcard ${isFlipped ? "flipped" : ""}`}
                                        onClick={handleFlip}
                                    >
                                        {/* Back Side */}
                                        <div className="flashcard-content">
                                            {/* Question */}
                                            {/* <h1 className="flashcard-term">
                                                {questions[currentQuestionIndex]?.kanji ||
                                                    questions[currentQuestionIndex]?.Hiragana ||
                                                    questions[currentQuestionIndex]?.Katakana}
                                            </h1> */}

                                            {/* Meaning */}
                                            <h1 className="flashcard-meaning">
                                                {questions[currentQuestionIndex]?.Meaning}
                                            </h1>

                                            {/* Display flash_card_meaning data with navigation */}
                                            {currentMeaningItem && (
                                                <div
                                                    className="flashcard-meaning-details"
                                                    style={{ maxHeight: '220px', paddingBottom: '24px', width: '100%', boxSizing: 'border-box' }}
                                                >
                                                    {hasMultipleMeanings && (
                                                        <button
                                                            className="flashcard-meaning-arrow flashcard-meaning-arrow-left"
                                                            onClick={handlePrevMeaning}
                                                            disabled={meaningIndex === 0}
                                                        >
                                                            ‹
                                                        </button>
                                                    )}
                                                    <div className="meaning-item">
                                                        <div className="japanese-word">
                                                            {currentMeaningItem.japanese}
                                                        </div>
                                                        <div className="meaning-text">
                                                            = {currentMeaningItem.meaning}
                                                        </div>
                                                    </div>
                                                    {hasMultipleMeanings && (
                                                        <button
                                                            className="flashcard-meaning-arrow flashcard-meaning-arrow-right"
                                                            onClick={handleNextMeaning}
                                                            disabled={meaningIndex === currentMeanings.length - 1}
                                                        >
                                                            ›
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* Front Side */}
                                        <div className="flashcard-content">
                                            {/* Kanji */}
                                            {questions[currentQuestionIndex]?.kanji && (
                                                <h1 className="flashcard-term">
                                                    {questions[currentQuestionIndex]?.kanji}
                                                </h1>
                                            )}

                                            {/* Hiragana */}
                                            {questions[currentQuestionIndex]?.Hiragana && (
                                                <h1 className="flashcard-term">
                                                    {questions[currentQuestionIndex]?.Hiragana}
                                                </h1>
                                            )}

                                            {/* Katakana */}
                                            {questions[currentQuestionIndex]?.Katakana && (
                                                <h1 className="flashcard-term">
                                                    {questions[currentQuestionIndex]?.Katakana}
                                                </h1>
                                            )}
                                        </div>

                                        {/* Flip Card Text */}
                                        <div
                                            className={`flip-text ${isFlipped ? "flipped" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent triggering other events
                                                handleFlip(); // Flip the card
                                            }}
                                            role="button"
                                            style={{ cursor: "pointer", userSelect: "none", position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)' }} // Position the button at the bottom
                                        >
                                            {Translate?.message?.data?.flipCard || "Flip Card"}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="flashcard-container">
                                        {showHelpAi && (
                                            <button
                                                className="help-ai-button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openAiModal();
                                                }}
                                            >
                                                Help AI
                                            </button>
                                        )}
                                        {isFlipped && questions[currentQuestionIndex]?.audio_file && (
                                            <button
                                                className="sound-icon"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleAudioPlayback(questions[currentQuestionIndex]?.audio_file);
                                                }}
                                            >
                                                <VolumeUpIcon className="volume-icon" />
                                            </button>
                                        )}
                                        <div
                                            className={`flashcard ${isFlipped ? "flipped" : ""}`}
                                            onClick={handleFlip}
                                        >
                                            {/* Front Side */}
                                            <div className="flashcard-content">
                                                {/* Kanji */}
                                                {questions[currentQuestionIndex]?.kanji && (
                                                    <h1 className="flashcard-term">
                                                        {questions[currentQuestionIndex]?.kanji}
                                                    </h1>
                                                )}

                                                {/* Hiragana */}
                                                {questions[currentQuestionIndex]?.Hiragana && (
                                                    <h1 className="flashcard-term">
                                                        {questions[currentQuestionIndex]?.Hiragana}
                                                    </h1>
                                                )}

                                                {/* Katakana */}
                                                {questions[currentQuestionIndex]?.Katakana && (
                                                    <h1 className="flashcard-term">
                                                        {questions[currentQuestionIndex]?.Katakana}
                                                    </h1>
                                                )}
                                            </div>

                                            {/* Back Side */}
                                            <div className="flashcard-content">
                                                {/* Question */}
                                                <h1 className="flashcard-term">
                                                    {questions[currentQuestionIndex]?.kanji ||
                                                        questions[currentQuestionIndex]?.Hiragana ||
                                                        questions[currentQuestionIndex]?.Katakana}

                                                </h1>

                                                {/* Meaning */}
                                                <h1 className="flashcard-meaning">
                                                    {questions[currentQuestionIndex]?.Meaning}
                                                    <hr className="meaning-divider" />
                                                </h1>

                                                {/* Display flash_card_meaning data with navigation */}
                                                {currentMeaningItem && (
                                                    <div
                                                        className="flashcard-meaning-details"
                                                        style={{ maxHeight: '220px', paddingBottom: '24px', width: '100%', boxSizing: 'border-box' }}
                                                    >
                                                        {hasMultipleMeanings && (
                                                            <button
                                                                className="flashcard-meaning-arrow flashcard-meaning-arrow-left"
                                                                onClick={handlePrevMeaning}
                                                                disabled={meaningIndex === 0}
                                                            >
                                                                <ArrowBackIcon className='icon_1' /> 
                                                            </button>
                                                        )}
                                                        <div className="meaning-item">
                                                            <div className="japanese-word">
                                                                {currentMeaningItem.japanese}
                                                            </div>
                                                            <div className="meaning-text">
                                                                = {currentMeaningItem.meaning}
                                                            </div>
                                                        </div>
                                                        {hasMultipleMeanings && (
                                                            <button
                                                                className="flashcard-meaning-arrow flashcard-meaning-arrow-right"
                                                                onClick={handleNextMeaning}
                                                                disabled={meaningIndex === currentMeanings.length - 1}
                                                            >
                                                               <ArrowForwardIcon className='icon_1' /> 
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Flip Card Text */}
                                            <div
                                                className={`flip-text ${isFlipped ? "flipped" : ""}`}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent triggering other events
                                                    handleFlip(); // Flip the card
                                                }}
                                                role="button"
                                                style={{ cursor: "pointer", userSelect: "none", position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)' }} // Position the button at the bottom
                                            >
                                                {Translate?.message?.data?.flipCard || "Flip Card"}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Progress Bar */}
                            <div className="progress-bar-container-flashcard">
                                <div className="progress-wrapper-flashcard">
                                    <div
                                        className="progress-bar-flashcard"
                                        style={{
                                            width: `${progress}%`,
                                        }}
                                    ></div>
                                </div>
                                <h1 className="progress-text-flashcard">
                                    {questions.length > 0 ? `${currentQuestionIndex + 1}/${questions.length}` : "No Questions"}
                                </h1>
                            </div>
                        </div>

                        {/* Right Side - Button */}
                        <div className="flashcard-right">
                            <button
                                className="FlashCard-action-button"
                                onClick={handleNextQuestion}
                            >
                                {Translate?.message?.data?.next || "Next"}
                            </button>
                            <button
                                className="FlashCard-action-button"
                                onClick={handleBackQuestion}
                            >
                                {Translate?.message?.data?.back || "Back"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {isAiModalOpen && (
                <div className="help-ai-modal-overlay" onClick={closeAiModal}>
                    <div
                        className="help-ai-modal"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div className="help-ai-modal-header">
                            <h3>Help AI</h3>
                            <button className="help-ai-close-button" onClick={closeAiModal}>
                                ×
                            </button>
                        </div>
                        <div className="help-ai-modal-toolbar">
                            <button
                                className={`help-ai-toggle-button ${aiLanguage === "english" ? "active" : ""}`}
                                onClick={() => setAiLanguage("english")}
                                disabled={!questions[currentQuestionIndex]?.ai_english_explain}
                            >
                                English
                            </button>
                            <button
                                className={`help-ai-toggle-button ${aiLanguage === "hindi" ? "active" : ""}`}
                                onClick={() => setAiLanguage("hindi")}
                                disabled={!questions[currentQuestionIndex]?.ai_hindi_explain}
                            >
                                Hindi
                            </button>
                            <button
                                className="help-ai-sound-button"
                                onClick={() => {
                                    const current = questions[currentQuestionIndex];
                                    if (!current) return;
                                    // Speak explanation in selected language
                                    if (aiLanguage === "english") {
                                        speakText(current.ai_english_explain, "en-US");
                                    } else {
                                        speakHindiExplainWithJapanese(current.ai_hindi_explain);
                                    }
                                    // Also speak the Japanese sentence/characters
                                    const japaneseText =
                                        current.kanji || current.Hiragana || current.Katakana;
                                    if (japaneseText) {
                                        speakJapanese(japaneseText);
                                    }
                                }}
                            >
                                <VolumeUpIcon />
                            </button>
                        </div>
                        <div className="help-ai-modal-body">
                            {aiLanguage === "english"
                                ? renderWithBold(
                                    questions[currentQuestionIndex]?.ai_english_explain ||
                                    "No English explanation available."
                                )
                                : renderWithBold(
                                    questions[currentQuestionIndex]?.ai_hindi_explain ||
                                    "No Hindi explanation available."
                                )}
                        </div>
                    </div>
                </div>
            )}
      <Footer />
    </div>
  );
};

export default FlashCard;
